export const data: any = {
  NEXT_PUBLIC_SITE_MACHINE_NAME: "sketchup",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "5qimfmsew7zl",
  NEXT_PUBLIC_ONETRUST_ID: "cd2b50ee-ef19-4d40-9f60-156844fb0f2f",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "prod_skup_trmb",
  BYPASS_CONSENT_CHECK: true
}
